import React from "react";
import { Card, CardContent, Typography, Box, CircularProgress } from "@mui/material";

// The only change is at the bottom of this file
const HeaderStatsCard = ({ 
  title, 
  count,
  total,
  subtitle, // New prop for the text below the numbers (e.g., "Centres")
  backgroundColor, 
  numberColor 
}) => {
  const progress = total > 0 ? (count / total) * 100 : 0;

  return (
    <Card
      sx={{
        display: 'flex', 
        flexDirection: 'column', 
        borderRadius: '1rem', 
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)', 
        backgroundColor: backgroundColor || "white",
        color: numberColor || "black", // Defaulting to black text on white background
        border: '1px solid #E0E0E0', // Light grey border as in the image
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': { 
          transform: 'scale(1.05)', 
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)', 
          borderColor: 'primary.main',
        },
        height: '100%',
        minHeight: '220px',
      }}
    >
      <CardContent 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'space-around',
          alignItems: 'center', 
          flexGrow: 1,
          p: 2 
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center", fontWeight: 'bold', }}>
          {title}
        </Typography>

        <Box sx={{ position: 'relative', display: 'inline-flex', my: 2 }}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={100}
            thickness={2}
            sx={{ color: 'rgba(0, 0, 0, 0.1)', position: 'absolute', left: 0 }}
          />
          <CircularProgress 
            variant="determinate" 
            value={progress} 
            size={100} 
            thickness={2} 
            sx={{ color: 'primary.main', '& .MuiCircularProgress-circle': { strokeLinecap: 'round' } }}
          />
          <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h6" component="div" fontWeight="bold" sx={{  color: 'primary.main' }}>
              {`${progress.toFixed(2)}%`}
            </Typography>
          </Box>
        </Box>

        {/* --- THIS IS THE UPDATED PART --- */}
        {/* It now displays the count/total and a subtitle */}
        <Typography variant="h6" sx={{ textAlign: "center", color: 'text.secondary' }}>
          {`${count} / ${total} ${subtitle}`}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default HeaderStatsCard;